export default __webpack_public_path__ + "src/assets/twitter.3cbd401b731d43cf9c3457eab80bffdd.svg";